import { useIsMobile } from '@/shared/utils'
import ClockIcon from '@/shared/assets/icons/clock.svg?react'
import { getTimeAgoFormatted } from '@/shared/utils/getTimeAgoFormatted'

export const PendingTime = ({ timeAgo }: { timeAgo: string }) => {
  const isMobile = useIsMobile()
  return (
    <>
      {isMobile && (
        <div className="flex items-center gap-2">
          <ClockIcon className="w-6 h-6 text-warning" />
          <div className="flex flex-col">
            <span className="font-medium text-warning">{getTimeAgoFormatted(timeAgo)}</span>
          </div>
        </div>
      )}
      {!isMobile && (
        <div className="flex items-center gap-2">
          <ClockIcon className="text-warning" />
          <div className="flex flex-col">
            <span className="font-medium text-warning">{getTimeAgoFormatted(timeAgo)}</span>
            <span className="text-text-secondary text-sm md:leading-[18px]">Время в статусе</span>
          </div>
        </div>
      )}
    </>
  )
}
